import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { PublicacoesEditaisSection } from 'volto-ministerio-publico-federal/components/View/CapaView/PublicacoesEditaisSection';
import {
  abaHasContent,
  toPublicacoesAbas,
  type PublicacoesData,
} from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

interface MpfPublicacoesEditaisBlockViewProps {
  data: PublicacoesData;
  /** Presente só no editor: `(slot da aba, índice do link)`. */
  onEditItem?: (aba: number, index: number) => void;
}

const EMPTY_TEXT =
  'Sem abas cadastradas. Preencha ao menos uma aba com links para a faixa aparecer na capa.';

/** Bloco "Publicações e Editais (capa)". */
const MpfPublicacoesEditaisBlockView = ({
  data,
  onEditItem,
}: MpfPublicacoesEditaisBlockViewProps) => {
  const isEmpty = !toPublicacoesAbas(data).some(abaHasContent);

  if (isEmpty) {
    return (
      <section className="rounded-md border border-dashed border-gray-300 p-4 dark:border-night-850">
        <h2 className="text-lg font-semibold text-on-surface dark:text-night-100">
          Publicações e Editais
        </h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-night-400">
          {data?.placeholder || EMPTY_TEXT}
        </p>
      </section>
    );
  }

  return (
    <PublicacoesEditaisSection data={data} isEditMode onEditItem={onEditItem} />
  );
};

export default withBlockExtensions(MpfPublicacoesEditaisBlockView);
